<script context="module" lang="ts">
    const predefined = {
        "error": {
            style: "--gacc100: var(--error); --gacc200: var(--error);",
            secondary: "var(--error)",
            colored: true,
        },
        "error-secondary": {
            style: "--gacc100: var(--error); --gacc200: var(--error);",
            secondary: "var(--error)",
            colored: false,
        },
        "active": {
            style: "color: var(--gacc200);",
            secondary: "var(--tacc)",
            colored: false,
        }
    };

    type PredefinedColor = keyof typeof predefined;
</script>

<script lang="ts">
    import { type Icon as IconId } from "$assets/icons";
    import Icon from "$lib/utility/Icon.svelte";
    import { CommandButton, type Command } from "ceyper-common";

    export let command: Command | undefined = undefined;
    export let icon: IconId;

    export let color: PredefinedColor | undefined = undefined;

    export let tooltip: string | undefined = undefined;
    export let iconOnly = false;
    export let disabled = false;

    $: colorSet = predefined[color as PredefinedColor] ? predefined[color as PredefinedColor] : { style: "", secondary: true, colored: false };

    $: style = colorSet.style;
    $: secondary = colorSet.secondary;
    $: colored = colorSet.colored;
</script>

<!----------------------------------------------------------------------------->
{#if command === undefined}
    <button class="icon-button" on:click class:icon-only={iconOnly} class:colored={colored} {style} title={tooltip} {disabled}>
        <Icon id={icon} parentHover={true} />
    </button>
{:else}
    <CommandButton {command} let:enabled let:invoke>
        <button class="icon-button" disabled={!enabled} on:click={() => invoke()} class:iconOnly class:colored={colored} {style} title={tooltip}>
            <Icon id={icon} parentHover={true} secondaryColor={enabled ? secondary : false} />
        </button>
    </CommandButton>
{/if}

<style>
    button:not(.icon-only) {
        height: unset;
        display: inline-grid;
        place-content: center;
        padding: 3px;
    }

    .icon-only {
        all: unset;
        display: inline-flex;

        &:hover, &:focus-visible {
            color: var(--tacc);
        }
    }

    .colored:where(:hover, :focus-visible) {
        color: var(--gacc100);
    }

    .colored:where(:active) {
        color: var(--gacc200);
    }

    .icon-button[disabled] {
        color: var(--t-disabled);
    }
</style>